// extracted by mini-css-extract-plugin
export default {"icon":"FilterButton_icon__Uv1Cr"};